import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { firstDayOfWeek, lastWorkDayOfWeek } from '@epicuro-next/utilities';

@Pipe({
  name: 'weekrangeDate',
  standalone: false,
})
/**
 * This pipe returns the starting date and end date of the week
 */
export class WeekrangeDatePipe implements PipeTransform {
  /**
   * @param value Pass in a date
   * @param format the format of each date
   */
  public transform(value: string, format: string = 'dd.MM.yyyy') {
    const parsedValue = Date.parse(value);
    if (isNaN(parsedValue)) return value;

    const dateFrom = new Date(parsedValue);

    const weekStartDate = this.datePipe.transform(
      firstDayOfWeek(dateFrom).toDateString(),
      format,
    );
    const weekEndDate = this.datePipe.transform(
      lastWorkDayOfWeek(dateFrom).toDateString(),
      format,
    );
    return `${weekStartDate} - ${weekEndDate}`;
  }

  constructor(private datePipe: DatePipe) {}
}
